import {SET_ANNOTATED_GSM_RESULT_LIST, SET_SPECTRUM_VIEWER_DATA} from "../actions/GsmResultsAction"

const gsmResultsReducer = (state = {annotatedGsmResultList: undefined, spectrum: {peaks: []}}, action) => {

    switch (action.type) {

        case SET_ANNOTATED_GSM_RESULT_LIST:
            return {
                ...state,
                annotatedGsmResultList: action.annotatedGsmResultList
            };
        case SET_SPECTRUM_VIEWER_DATA:
            return {
                ...state,
                spectrum: action.spectrum
            };
        default:
            return state;
    }
};

export default gsmResultsReducer